import { Logger, Presenter } from 'wdc-cube'

import { WaitingScope } from '../../the-connection/tc_scopes'
import ConfigurationPresenter from './presenter'
import { EmailConfigScope, SmtpConfig } from './scopes'
import { MailConfigService } from './service'

const LOG = Logger.get('MailConfigPresenter')
const service = MailConfigService.singleton()

export class EmailConfigPresenter extends Presenter<EmailConfigScope, ConfigurationPresenter> {
    // :: Constructor

    public constructor(owner: ConfigurationPresenter) {
        super(owner, owner.scope.emailConfig)
        this.__parent = owner
    }

    // :: Instance

    private readonly __parent: ConfigurationPresenter

    // :: Methods

    public override release() {
        super.release()
    }

    async initialize() {
        LOG.debug('initialize')
        this.scope.onSave = this.action(this.handleSave)
        this.scope.onConfigChanged = this.action(this.handleConfigChanged)
        this.scope.onLoadData = this.action(this.onLoadData)
        await this.onLoadData()
    }

    async onLoadData() {
        try {
            this.scope.waiting = new WaitingScope()
            this.scope.templates = await service.fetchTemplates()
            const config = await service.fetchConfig()
            this.scope.config = config ?? ({} as SmtpConfig)
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async handleSave() {
        try {
            this.scope.waiting = new WaitingScope()
            this.scope.config = await service.saveConfig(this.scope.config)
            this.__parent.app.notify('success', 'Salvo com sucesso')
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async handleConfigChanged(cfg: Partial<SmtpConfig>) {
        this.scope.config = {
            ...this.scope.config,
            ...cfg
        }
    }
}

export default EmailConfigPresenter
